module.exports = __webpack_public_path__ + "img/logo-orion-new.5bfb8864.jpeg";